import { useQuery } from '@tanstack/react-query';
import type { CurrentUser } from '@pst/shared';
import { api } from '../api';

/**
 * The signed-in user, from the cache App already filled. Used to show only
 * what the user may do; the server checks every action again regardless.
 */
export function useMe(): CurrentUser | undefined {
  return useQuery({ queryKey: ['me'], queryFn: api.me }).data;
}

export function useCan(permission: string): boolean {
  return useMe()?.permissions.includes(permission) ?? false;
}
